import { Component, OnInit, Input, Output, EventEmitter, ElementRef } from '@angular/core';
import { UtilsService } from '../../rl-common/shared/core/utils.service';
import { EntityType } from '../../rl-common/shared/shared/entity-type.enum';
import { StrMarker } from '../../rl-common/shared/shared/types/strMarker';
import { Tag } from '../../store/model/tag.model';
import { TagDisplay } from '../tag/tag-display';

@Component({
  selector: 'rl-select-tag',
  templateUrl: './select-tag.component.html',
  styleUrls: ['./select-tag.component.scss', './select-tag.component-rtl.css']
})
export class SelectTagComponent implements OnInit {
constructor(private utilsService: UtilsService, private e: ElementRef) {}

  @Input() label?: string; // default label is 'Add Tag' but maybe we will want a label with the type 'Add Tag to Item'
  /** for private tags*/
  @Input() freeTextEnabled?: boolean;
  @Input() tags: Tag[];
  @Input() entityType: EntityType;

  @Output() onSelect: EventEmitter<Tag> = new EventEmitter<Tag>();

  addTagsOpen: boolean = false;
  shortLengthWarn: boolean = false;
  tag: string;
  oldTagSelected: string;
  uniqueId: string;
  cuurentTagDisplay: TagDisplay;

  ngOnInit(): void {
    this.uniqueId = this.e.nativeElement.id;
    if (!this.label) this.label = 'tags.links.' + this.entityType;
  }

  select(tag: TagDisplay) {
    this.onSelect.emit(new Tag(tag));
    this.resetForm();
  }

  openTagSelect() {
    this.addTagsOpen = !this.addTagsOpen;
  }

  addPrivateTag(event: any) {
    if (this.freeTextEnabled && this.tag.length > 2) {
      this.select(new TagDisplay(this.tag, this.tag, 'PRIVATE', undefined, '0'));
    } else if (this.freeTextEnabled) {
      this.shortLengthWarn = true;
    }
    this.stopEvent(event);
  }

  keyDown(event: any) {
    if (event.code === 'Tab') {
      this.select(this.cuurentTagDisplay);
    }
  }

  resetForm() {
    this.tag = '';
    this.shortLengthWarn = false;
    this.addTagsOpen = false;
  }

  blur(event: any) {
    if (event?.item && event.item instanceof TagDisplay) {
      this.cuurentTagDisplay = event.item;
    }
    if (event?.code === 'Tab') {
      return;
    }
    this.resetForm();
  }

  addSpaceToTerm(event: any) {
    this.tag = this.tag + ' ';
    this.stopEvent(event);
  }

  stopEvent(event: any) {
    event.stopPropagation();
    event.preventDefault();
  }

  findMarkers(tagName: string): StrMarker[] {
    let markers: StrMarker[] = [];
    if (!tagName || !this.tag?.length) return markers;
    return this.utilsService.findMarkers(tagName, this.tag);
  }
}
